import { render, staticRenderFns } from "./WechatWelcoming.vue?vue&type=template&id=0e40c333&scoped=true"
import script from "./WechatWelcoming.vue?vue&type=script&lang=js"
export * from "./WechatWelcoming.vue?vue&type=script&lang=js"
import style0 from "./WechatWelcoming.vue?vue&type=style&index=0&id=0e40c333&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e40c333",
  null
  
)

export default component.exports